const getters2 = {
  isHandle: state => state.other.isHandle,
  isCallArr: state => state.other.isCallArr,
  alarmInfo: state => state.other.alarmInfo,
  callOut: state => state.other.callOut,
  zgVideoObj: state => state.other.zgVideoObj,
  serviceInfo: state => state.other.serviceInfo,

  companyHandle: state => state.company.companyHandle,
  orderInfo: state => state.company.orderInfo
}
export default getters2



// WEBPACK FOOTER //
// ./src/store/getters2.js